export enum LayoutPageAndMapModalPositionFlags {
  SHOW_MODAL_POSITION,
}
